import type { ModalProps } from '@omnipresentgroup/design-system';

import { IntegrationWidgetModal } from '../../../components';

const INTEGRATION_STEPS = [
  { id: 1, text: 'Click Start integration to generate your magic link.' },
  { id: 2, text: 'Copy your magic link and open it in a browser window.' },
  {
    id: 3,
    text: 'Select your HRIS and follow the instructions of how to integrate it.',
  },
  {
    id: 4,
    text: 'Don’t have the right permissions in your HRIS? Just share your magic link with a colleague who does.',
  },
];

const WHAT_MERGE_DESCRIPTION = `Integrate your HRIS so time off data automatically flows to the
              OmniPlatform. We integrate with 50+ HRIS' including HiBob, BambooHR
              and Personio.`;
const WHY_MERGE_DESCRIPTION = `Avoid any duplication of logging time off for your employees. Keep
              your HRIS as your source of truth, while the data flows to the
              OmniPlatform in the background.`;

type MergeIntegrationModalProps = {
  modalProps: Omit<ModalProps, 'children'>;
  handleClose: () => void;
  canConfigure?: boolean;
  isConnected: boolean;
  action: JSX.Element;
};

export const MergeIntegrationModal = ({
  modalProps,
  handleClose,
  canConfigure,
  isConnected,
  action,
}: MergeIntegrationModalProps) => (
  <IntegrationWidgetModal
    integrationName="Merge"
    whatDescription={WHAT_MERGE_DESCRIPTION}
    whyDescription={WHY_MERGE_DESCRIPTION}
    steps={canConfigure && !isConnected ? INTEGRATION_STEPS : undefined}
    modalProps={modalProps}
    handleClose={handleClose}
    faqsLink="https://help.omnipresent.com/en/articles/6448424-setting-up-hris-integration?q=merge"
    action={action}
  />
);
